<template>
  <div class="StudentManagement">

    <div style="display: flex;width: 100%; justify-content: end;"> 
      <p style="text-align: right; margin-bottom: 30px; padding-right: 30px;"><el-button type="primary" @click="AddStudentManagement1" icon="el-icon-setting" size="small" class="btns">审批设置</el-button></p>
      <p style="text-align: right; margin-bottom: 30px; padding-right: 30px;"><el-button type="primary" @click="AddStudentManagement" icon="el-icon-plus" size="small" class="btns">添加</el-button></p>
    </div>
   
    <el-table :data="tableData" border style="width: 100%" height="800" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
      <el-table-column prop="subjectGroupName" label="学科组" width="200"></el-table-column>
      <el-table-column prop="manageName" label="学管">  </el-table-column>
      <el-table-column prop="categoryNames" label="科目">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="140">
        <template v-slot="scope">
          <el-button type="text" size="small" @click="edit(scope.row.id,'详情')">详情</el-button>
          <el-button type="text" size="small" @click="edit(scope.row.id,'编辑')">编辑</el-button>
          <el-button type="text" size="small" @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="paging.pageNum"
      :page-size="paging.pageSize" layout="total, prev, pager, next" :total="total">
    </el-pagination>
   

    <el-dialog :title="titleisShow" :visible="dialogFormVisible" width="50%" style="text-align: left;" @close="dialogFormVisibleclose">
      <el-form label-width="70px">

        <el-form-item label="学科组">
          <!-- <el-select v-model="managementObj.teacherIds" multiple placeholder="请选择教师(教师可多选)" style="width:80%;" :disabled="isDisable">
            <el-option v-for="item in teacherArr" :key="item.id" :value="item.id" :label="item.realname">
            </el-option>
          </el-select> -->
          <el-input v-model="managementObj.teacherIds" clearable placeholder="请输入学科组" style="width:80%;" :disabled="isDisable"></el-input>
        </el-form-item>


        <el-form-item label="学管">
          <el-select v-model="managementObj.manageId" style="width: 80%;" placeholder="请选择课管" :disabled="isDisable">
            <el-option v-for="item in classTeacher" :value="item.id" :key="item.id" :label="item.realname"></el-option>
          </el-select>
        </el-form-item>
     
        
        <el-form-item label="科目">
          <el-select v-model="managementObj.categoryIds" multiple placeholder="请选择科目(科目可多选)" style="width:80%;" :disabled="isDisable">
            <el-option v-for="item in teacherArrr" :key="item.id" :value="item.id" :label="item.categoryName">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <template v-slot:footer>
        <div  class="dialog-footer">
          <el-button @click="dialogFormVisibleclose">取 消</el-button>
          <el-button type="primary" @click="save" v-if="!isDisable">确 定</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="详情" :visible="flog" width="40%" style="text-align: left;">
      <el-form label-width="70px">

        <el-form-item label="学科组">
          {{ this.teacherName }}
        </el-form-item>


        <el-form-item label="课管">
          {{ this.manageName }}
        </el-form-item>
        <!-- <el-form-item label="销售">
          {{ this.marketName }}
        </el-form-item> -->
       
        <el-form-item label="科目">
          {{ this.categoryNames }}
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <div class="dialog-footer">
          <el-button @click="flog = false">取 消</el-button>
          <el-button type="primary" @click="flog = false">确 定</el-button>
        </div>
      </template>
    </el-dialog>





    <el-dialog title="审批设置" :visible="dialogFormVisibles" width="50%" style="text-align: left;" @close="handleCler">
      <el-form label-width="120px">

        <el-form-item label="审批层级设置">
          <el-select v-model="input1" style="width: 80%;" placeholder="请选择审批层级设置" >
            <el-option v-for="item in optionList1" :value="item.id" :key="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
     
        
        <el-form-item label="一级审批设置" v-if="input1 === 1 || input1 === 2">
          <el-select v-model="input2"  placeholder="请选择一级审批设置" style="width:80%;"   clearable @change="handleSetList">
            <el-option v-for="item in optionList2" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>

       <el-form-item label="二级审批设置" v-if="input1 === 2">
          <el-select v-model="input3"  placeholder="请选择二级审批设置" style="width:80%;"   clearable @change="handleSetLists">
            <el-option v-for="item in optionList3" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <template v-slot:footer>
        <div  class="dialog-footer">
          <el-button size="small" class="btns" @click="handleCler">取 消</el-button>
          <el-button size="small" class="btns" type="primary" @click="handleSubt">保存</el-button>
        </div>
      </template>
    </el-dialog>





  </div>
</template>

<script>
import { getDataList, getTeachers, AddSave, editSave, getDetails, delItem } from "@/api/StudentManagementApi"
import { getSubject, } from "@/api/firstClassApi";
import axios from "axios";
import apiBaseUrl from "../../../config/api";
export default {
  data () {
    return {
      isDisable: false,
      dialogFormVisible: false,//控制显示隐藏
      isShow: true,
      flog: false,
      teacherName: "",
      categoryNames:'',
      manageName: '',
      marketName: '',
      managementObj: {
        manageId: [],//课管ID
        teacherIds: '',//老师ID
        marketIds: [],
        categoryIds: [],
        id: ''
      },
      tableData: [],//table表格数据
      teacherArr: [],//所有老师
      classTeacher: [],//所有课管
      marketArr: [],//所有销售
      total: 0,
      paging: {///分页
        pageNum: 1,
        pageSize: 10,
      },


      titleisShow:'',
      teacherArrr: [],

      dialogFormVisibles: false,

      input1:'',
      input2:'',
      input3:'',
      optionList1: [{id:1,name:'一级审批'},{id:2,name:'二级审批'}],
      optionList2: [{id:1,name:'学管'},{id:2,name:'规划师'}],
      optionList3: [{id:1,name:'学管'},{id:2,name:'规划师'}],
      ids: '',
    }
  },
  created () {
    this.getList()
    this.getTeacherList()
  },

  mounted () {
    getSubject().then((res) => {  this.teacherArrr = res.data })
  },
  methods: {

    handleSetList(e){
     if(e === 1){
       this.optionList3 = [{id:2,name:'规划师'}]
     }
     else if(e === 2){
       this.optionList3 = [{id:1,name:'学管'}]
     }
     else{
       this.optionList2 = [{id:1,name:'学管'},{id:2,name:'规划师'}]
     }  
    },

    handleSetLists(e){
     if(e === 1){
       this.optionList2 = [{id:2,name:'规划师'}]
     }
     else if(e === 2){
       this.optionList2 = [{id:1,name:'学管'}]
     }
     else{
       this.optionList3 = [{id:1,name:'学管'},{id:2,name:'规划师'}]
     }
    },

    dialogFormVisibleclose () {
       this.managementObj = {
        manageId: [],//课管ID
        teacherIds: '',//老师ID
        marketIds: [],
        categoryIds: [],
        id: ''
      }

      this.dialogFormVisible = false
      this.titleisShow = ''

    },
    //获取table表格数据
    getList () {
      getDataList(this.paging).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },
    //获取所有老师
    getTeacherList () {
      getTeachers().then(res => {
        this.teacherArr = res.data
        this.classTeacher = res.data
        this.marketArr = res.data
      })
    },
    //添加按钮
    AddStudentManagement () {
      this.isShow = true
      this.isDisable = false
      this.dialogFormVisible = true
      this.titleisShow = '添加'
      this.managementObj = {}
    },

    handleCler () {
      this.dialogFormVisibles = false
      this.ids = ''
      this.input1 = ''
      this.input2 = ''
      this.input3 = ''
    },
    handleSubt () {
      let data = {
        id: this.ids,
        approvalLevels: this.input1,
        firstLevelApproval: this.input2,
        secondLevelApproval: this.input3,
      }
      axios.post(`${apiBaseUrl}/approvalSettings/updateApprovalSettings`, data, { headers:{'authorization': sessionStorage.getItem('tokenInfo') } }) .then(res => {
          if (res.data.code == 200) {
            this.$message({ type: 'success', message: res.data.message || res.data.meg || '结课成功' });
            this.dialogFormVisibles = false
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
          } else {
            this.$message({ type: 'error',  message: '保存失败' || res.data.message || res.data.meg });
          }
      }).catch(error => {
         this.$message({ type: 'error',  message: error });
      })
    },

    AddStudentManagement1 () {
      this.dialogFormVisibles = true

      axios.get(`${apiBaseUrl}/approvalSettings/getApprovalSettings`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if(res.data.code === 200){
          let data = res.data.data && res.data ? res.data.data[0] : {}
          console.log(data)
          this.ids = data.id
          this.input1 = data.approvalLevels
          this.input2 = data.firstLevelApproval
          this.input3 = data.secondLevelApproval 


          if(this.input2 === 1){
            this.optionList3 = [{id:2,name:'规划师'}]
          }
          if(this.input2 === 2){
            this.optionList3 = [{id:1,name:'学管'}]
          }

          if(this.input3){
            this.optionList2 = [{id:2,name:'规划师'}]
          }
          if(this.input3 === 2){
            this.optionList2 = [{id:1,name:'学管'}]
          }

        }else{
          this.ids = ''
          this.input1 = ''
          this.input2 = ''
          this.input3 = ''
        }
      }).catch(error => {
        this.$message({ message:error,  type: "error"   });
      })
    },
    //编辑回显
    edit (id,type) {

      if(type === '详情'){
        this.titleisShow = '详情'
        this.isDisable = true
      }

      if(type === '编辑'){
        this.titleisShow = '编辑'
        this.isDisable = false
      }

      this.isShow = false
      this.dialogFormVisible = true
      this.managementObj.id = id

      getDetails(id).then(res => {

        if(res.code === 200){
          this.managementObj.manageId = (res.data && res.data.manageId) ? res.data.manageId : ''
          this.managementObj.teacherIds = res.data.subjectGroupName
          this.managementObj.marketIds = (res.data && res.data.marketIds) ? res.data.marketIds.split(",").map(id => parseInt(id)) : []
          this.managementObj.categoryIds = (res.data && res.data.categoryIds) ? res.data.categoryIds.split(",").map(id => parseInt(id)) : []
        }else{
          this.managementObj.manageId = ''
          this.managementObj.teacherIds = ''
          this.managementObj.marketIds = []
          this.managementObj.categoryIds = []
        }

      })

    },
    //详情
    details (id) {
      this.flog = true

      getDetails(id).then(res => {
        this.manageName = res.data.manageName
        this.teacherName = res.data.teacherName
        this.marketName = res.data.marketName
        this.categoryNames = res.data.categoryNames
      })

    },
    //保存
    save () {

      this.managementObj.marketIds = this.managementObj.marketIds && this.managementObj.marketIds.length > 0 ? this.managementObj.marketIds.join(',') : ''
      this.managementObj.manageId = this.managementObj.manageId
      this.managementObj.categoryIds = this.managementObj.categoryIds && this.managementObj.categoryIds.length > 0 ? this.managementObj.categoryIds.join(',') : ''
      this.managementObj.subjectGroupName = this.managementObj.teacherIds

       this.managementObj.teacherIds = ''

      if (this.isShow) {
        //添加保存
        AddSave(this.managementObj).then(res => {
          if (res.code == 200) {
            this.$message.success(res.message)
            this.managementObj= {  manageId: [], teacherIds: '', marketIds: [],  id: ''  }
            this.dialogFormVisible = false
            this.getList()
            this.handleSubjectGroupList()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        //编辑保存


        editSave(this.managementObj).then(res => {
          if (res.code == 200) {
            this.$message.success(res.message)
            this.managementObj= {  manageId: [], teacherIds: '', marketIds: [],  id: ''  }
            this.dialogFormVisible = false
            this.getList()
            this.handleSubjectGroupList()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    
    //删除
    del (id) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delItem(id).then(res => {
          if (res.code == 200) {
            this.$message.success(res.message)
            this.getList()
            this.handleSubjectGroupList()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
        this.$message({   type: 'info',   message: '已取消删除'    });
      });
    },
    handleSizeChange (size) {
      this.paging.pageSize = size;
      this.getList();
    },

    handleSubjectGroupList(){
      axios.get(`${apiBaseUrl}/courseManage/getSubjectList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if(res.data.code === 200){
          let data = res.data.data.map(fore => {
            fore.teacherId = fore.categoryIds
            fore.teacherName = fore.subjectGroupName
            return  fore
          })
          sessionStorage.setItem('SubjectGroupList',JSON.stringify(res.data.data))
        }else{
          sessionStorage.setItem('SubjectGroupList',JSON.stringify([]))
        }
      }).catch(error => {
        this.$message({ message:res.data.message ? res.data.message : res.data.meg,  type: "error"   });
      })
    },

    handleCurrentChange (v) {
      this.paging.pageNum = v;
      this.getList();
    },
  }
}
</script>

<style scoped>
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/StudentManagement.vue